const initialState = {
  SeatInfoQueryResult: [],
};

// 取消订单参数
export default function SeatInfoQuery(state = initialState, action) {
  switch (action.type) {
  case 'GET_SEAT_INFO':
    return { ...state, SeatInfoQueryResult: action.payload };
  default:
    return state;
  }
}